/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Source_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Select source event group" |
*
* @param {Segment_Event_Group_Source_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_source_aria_label = /** @type {((inputs?: Segment_Event_Group_Source_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Source_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionner le groupe d'evenements source")
	if (locale === "de") return /** @type {LocalizedString} */ ("Quellereignisgruppe auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona il gruppo di eventi di origine")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите группу исходных событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar el grupo de eventos de origen")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择源事件组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ソースイベントグループを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्रोत घटना समूह का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o grupo de eventos de origem")
	return /** @type {LocalizedString} */ ("Select source event group")
});